<template>
  <div class="single-choice">
    <van-radio-group :value="issue.select" checked-color="var(--theme-color)">
      <div v-for="(group, index) in issue.item_groups" :key="index" class="mb-3 last:mb-0">
        <div class="cg-title text-base break-words">
          <span> {{ group.title }}</span>
        </div>
        <ul class="cg-content">
          <li
            v-for="item in group.options"
            :key="item.id"
            class="mb-2 last:mb-0 choice-item-wrap"
            :class="{ selected: item.id === issue.select }"
          >
            <single-choice-item
              :value="issue.select"
              :item="item"
              @click="onChangeValue"
              :correct-answer-list="correctAnswerList"
            />
            <template v-if="item.id === issue.select">
              <div class="px-2">
                <relation-input
                  :type="item.inputType"
                  v-if="item.is_other_item"
                  v-model="item.value"
                  class="my-2"
                  :question-type="question.questionType"
                  :question-id="question.id"
                  :option-id="item.id"
                  :enable-relation="item.setting.enableRelation"
                  :max-length="item.maxLength"
                  :min-length="item.minLength"
                  :validate="item.validate"
                  :allow-error-list="item.allowErrorList"
                  :placeholder="item.placeholder"
                />
                <!--                <van-field :type="item.inputType" v-if="item.is_other_item" v-model="item.value" class="my-2" />-->
              </div>
              <adapter-upload-files :content="item.content" class="my-2" />
            </template>
            <vote-progress
                v-if="showVoteProgress && changeExpr"
                :vote="question.vote"
                :label="item.id"
                :checked="item.id === issue.select"
                :selected="!!issue.select"
            />
          </li>
        </ul>
      </div>
    </van-radio-group>
  </div>
</template>

<script>
import SingleChoiceItem from '@/questions/components/SingleChoiceItem'
import AdapterUploadFiles from '@/questions/components/AdapterUploadFiles'
import RelationInput from '../components/RelationInput'
import VoteProgress from '../components/VoteProgress.vue'

export default {
  name: 'SingleChoice',
  components: { VoteProgress, RelationInput, AdapterUploadFiles, SingleChoiceItem },
  data() {
    return {}
  },
  changeExpr: 'changeExpr',
  computed: {
    changeExpr() {
      let item = this.issue.getItemById(this.issue.select)
      if (item) {
        return item.id + item.value + item.content.fileList.length
      } else {
        return ''
      }
    },
    correctAnswerList() {
      if (!this.view) return []
      return this.question.getCorrectAnswerList()
    }
  },
  methods: {
    onChangeValue(item) {
      if (item.id === this.issue.select) {
        if (!this.question.required) {
          this.issue.select = ''
        }
      } else {
        this.issue.select = item.id
      }
    }
  }
}
</script>
